import React from 'react';
import DeviceMockup from './DeviceMockup';
import Caption from '../Caption';

const DeviceGridx1 = ({first, style, themeColor, caption}) => (
  <section>
    <div className="col col-1" style={{backgroundColor: themeColor,}}>
      <div className="hero hero--s hero__inner" style={style}>
        <div className="hero-img">
            <DeviceMockup screenshot={first}/>
        </div>
      </div>
      {caption !== undefined
        ? <Caption captionText={caption}/>
        : null
      }
    </div>
  </section>
);

export default DeviceGridx1;



// WEBPACK FOOTER //
// ./src/layout/portfolio/DeviceGridx1.js